<template>
    <div  class="casestudiesitemlarge"  >

        <div class="columncaseleft">
            <div @click="fnBack" class="backlink"> 
                <img src="@/assets/images/arrow_left.svg" /><br/><b>{{backlabel}}</b>
            </div>
            <div class="categoria_casestudiesitemlarge"><span>{{categorialabel}} | </span><span class="yellowbold">{{ caseitemlarge.category }}</span></div>        
        </div>
        <div class="columncasecenter">
          <div class="title_columncasecentercontainer">
              <div class="top_side">
                  <span class="title_columncasecenter">{{ caseitemlarge.title }}</span>
                  <span class="company_columncasecenter">{{ caseitemlarge.company }}<span v-if="caseitemlarge.company!=''">&nbsp;|&nbsp;</span>{{ caseitemlarge.year }}</span>
              </div>
              <div class="middle_side">
                  <img :src="defaultimagesrc" />
              </div>
              <div class="disclaimer">{{disclaimerlabel}}</div>
              <div class="bottom_side" >
                  <a v-if="caseitemlarge.url!='' && isyoutube==true" target="_blank"  :href="caseitemlarge.url">{{youtubelabel}}</a> 
                  <a v-if="caseitemlarge.url!='' && isyoutube==false" target="_blank"  :href="caseitemlarge.url">{{caseitemlarge.url}}</a> 
              </div>
              
              
          </div>
        </div>
        <div class="columncaseright">
          <div class="description_columncasecentercontainer">
              {{ caseitemlarge.description }}
          </div>
          <div class="images_columncasecentercontainer"> 
                <img :src="image1src" @click="fnSwap(1)" />
                <img :src="image2src" @click="fnSwap(2)" />
                <img :src="image3src" @click="fnSwap(3)" />
          </div>
        </div>


       
    </div>
 
</template>

<script>
import backendmixin from '../mixins/backendmixin.js';
import multilangmixin from "../mixins/multilangmixin.js"
// eslint-disable-next-line no-unused-vars

export default {
  
  name: "cmpcasestudieslarge",
  mixins:[multilangmixin,backendmixin],
  props:["caseitemlarge"],
    

  data(){
      return {

                  "tempdefaultimage":"",
                  "tempimage1":"",
                  "tempimage2":"",
                  "tempimage3":""
                  


            };
  },

  created(){
    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);
    
    
  },


  mounted(){

    
    this.tempdefaultimage=this.caseitemlarge.defaultimage;
    this.tempimage1=this.caseitemlarge.image1;
    this.tempimage2=this.caseitemlarge.image2;
    this.tempimage3=this.caseitemlarge.image3;

    
  },

  computed:{

       isyoutube(){
        if (this.caseitemlarge.url.search("youtu") >=0) 
        {
            return true;
        }
        else
        {
          return false;
        }
      },

      defaultimagesrc(){
        if (this.tempdefaultimage=="")
        {
          return "";
        }
        else
        {
          return this.fnGetImageUrl(this.tempdefaultimage);
        }
        
      },
      keyurl(){
        return "/"+this.currentlang+"/caseitem?key="+this.caseitemlarge.key;
      },
      categorialabel()
      {
        return this.fnGetTranslation(this.currentlang, "categoria").toUpperCase();
      },
      backlabel()
      {
        return this.fnGetTranslation(this.currentlang, "back");
      },
      disclaimerlabel()
      {
        return this.fnGetTranslation(this.currentlang, "disclaimer");
      },
      youtubelabel()
      {
        return this.fnGetTranslation(this.currentlang, "youtube");
      },



      image1src(){
        if (this.tempimage1=="")
        {
          return "";
        }
        else
        {
          return this.fnGetImageUrl(this.tempimage1);
        }
      },

      image2src(){
        if (this.tempimage2=="")
        {
          return "";
        }
        else
        {
          return this.fnGetImageUrl(this.tempimage2);
        }
      },

      image3src(){
        if (this.tempimage3=="")
        {
          return "";
        }
        else
        {
          return this.fnGetImageUrl(this.tempimage3);
        }
      },

  },


  methods:{
      fnBack(){
        this.$router.go(-1);
      },


      fnSwap(piIndex)
      {
        if (piIndex==1)
        {
          let c=this.tempdefaultimage;
          this.tempdefaultimage=this.tempimage1;
          this.tempimage1=c;
        }
        else if (piIndex==2)
        {
          let c=this.tempdefaultimage;
          this.tempdefaultimage=this.tempimage2;
          this.tempimage2=c;
        }
        else if (piIndex==3)
        {
          let c=this.tempdefaultimage;
          this.tempdefaultimage=this.tempimage3;
          this.tempimage3=c;
        }


      }

  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    
    
     .casestudiesitemlarge{
        display: flex;
        justify-content:  center;
    }

    .casestudiesitemlarge > div{
      min-height: 800px;
      
    }



/*---------------------left*/

    .columncaseleft{
      
      width: 10vw;
      padding-left: 2vw;
      
    }


    .backlink{
      font-size: 0.8em;
      margin-top: 80px;
    }

    .backlink img{
      transform: rotate(180deg);
      width: 20%;
      max-width: 50px;
      cursor: pointer;
    }
    

    .categoria_casestudiesitemlarge  
    {
      margin-top: 15vh;
      writing-mode: vertical-rl;
      font-size: 0.8em;
      font-weight: 400;
      
    }


    .yellowbold
    {
      color: #ffdd00;
      font-weight: bold;

    }


/*---------------------left*/





/*---------------------center*/



    .columncasecenter{
        
        width: 45vw;
    }
    


  .title_columncasecentercontainer{
      
      font-weight: bold;
      font-size: 1em;
  }

  .title_columncasecenter{
      
    text-transform: uppercase;
  }



  .top_side{
    height: 50px;
    
    
  }

  
    .company_columncasecenter
    {
      margin-left: 50%;
      font-size: 0.8em;
      font-weight: 400;
      
    }
 


  .middle_side img{
    width: 100%;
  }


  .bottom_side{
    margin-top: 3vh;
    text-align: center;
    font-size: 0.9em;
    font-weight:400;
  }
 
  .disclaimer{
    font-size: 0.5em;
    text-align: right;
  }


  .bottom_side a 
  {
    color: black; 
    text-decoration: none;
  }

  .bottom_side  a:visited{
    color: black;
    text-decoration: none;
  }

  .bottom_side a:active{
    color: black;
    text-decoration: none;
  }

  .bottom_side a:hover{

  color: #ffdd00;
  font-weight: bold;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-color: white;
  text-decoration-thickness: 0.3em;
  }




/*---------------------center*/





/*---------------------right*/


    .columncaseright{
      
      
      width: 22vw;
      max-width: 300px;
      padding-left: 3vw;
      padding-right: 3vw;
      
      

    }



    .description_columncasecentercontainer{
      
        font-size: 0.8em;
         white-space: pre-line;

         margin-bottom: 0px;

         height: 30%;

    }



    .images_columncasecentercontainer
    {

       
        bottom: 0px;
        display: flex;
        flex-direction: column-reverse;
        align-self:flex-end;
        height: 70%;
    }

    .images_columncasecentercontainer img
    {
      margin-top: 2vh;
      width: 100%;
      cursor: pointer;
      
    }



/*---------------------right*/



 

  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
    
   
  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
    
     
 
  }


</style>
